var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadGreenSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 29,
    rx: 5,
    fill: "#25B003"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 16.9C6.77614 16.9 7 17.1239 7 17.4V19.9C7 20.4523 7.44772 20.9 8 20.9H20C20.5523 20.9 21 20.4523 21 19.9V17.4C21 17.1239 21.2239 16.9 21.5 16.9C21.7761 16.9 22 17.1239 22 17.4V19.9C22 21.0046 21.1046 21.9 20 21.9H8C6.89543 21.9 6 21.0046 6 19.9V17.4C6 17.1239 6.22386 16.9 6.5 16.9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6464 8.14645C13.8417 7.95118 14.1583 7.95118 14.3536 8.14645L17.3536 11.1464C17.5488 11.3417 17.5488 11.6583 17.3536 11.8536C17.1583 12.0488 16.8417 12.0488 16.6464 11.8536L14.5 9.70711V18.5C14.5 18.7761 14.2761 19 14 19C13.7239 19 13.5 18.7761 13.5 18.5V9.70711L11.3536 11.8536C11.1583 12.0488 10.8417 12.0488 10.6464 11.8536C10.4512 11.6583 10.4512 11.3417 10.6464 11.1464L13.6464 8.14645Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadGreenSvg);
export default __webpack_public_path__ + "static/media/upload-green-svg.8a56166e428163275bc39237345c371a.svg";
export { ForwardRef as ReactComponent };